<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <!-- Breadcrumb Navigation -->
      <nav
        class="d-flex align-items-center flex-wrap gap-2 mb-2"
        aria-label="breadcrumb"
      >
        <a
          class="back-link d-flex align-items-center justify-content-center rounded-circle text-decoration-none"
          routerLink="/applicationConfiguration"
          [title]="'COMMON.BACK' | translate"
          (click)="goBack()"
        >
          <mat-icon class="text-primary">arrow_back</mat-icon>
        </a>

        <div class="d-flex align-items-center">
          <mat-icon class="me-3" color="primary">payment</mat-icon>
          <p class="fw-semibold mb-0" style="font-size: 20px">
            {{ "PaymentS.Payment_configuration" | translate }}
          </p>
        </div>

        <span class="text-secondary mx-2">/</span>
        <span class="text-secondary">{{
          "PaymentS.Gateway_Settings_Title" | translate
        }}</span>
      </nav>
    </div>
    <div class="col-12">
      <div class="card">
        <!-- Card Header -->
        <div class="card-header d-flex p-3">
          <h5 class="card-title mb-0">
            {{ "PaymentS.Payment_Gateway_Configuration" | translate }}
          </h5>
        </div>

        <!-- Card Body -->
        <div class="card-body compact-inputs">
          <!-- Alerts -->
          <p *ngIf="form['error'] == false && form['message']">
            <app-ncs-alert
              [message]="form['message']"
              type="success"
              showAlert="true"
            ></app-ncs-alert>
          </p>
          <p *ngIf="form['error'] == true && form['message']">
            <app-ncs-alert
              [message]="form['message']"
              type="danger"
              showAlert="true"
            ></app-ncs-alert>
          </p>

          <!-- Payment Config Form -->
          <form #paymentForm="ngForm" class="row g-3">
            <!-- Gateway Name -->
            <div class="form-group col-12 mb-2">
              <label class="form-label">{{
                "PaymentS.Form.Gateway_Name" | translate
              }}</label>

              <mat-form-field appearance="outline" class="w-100">
                <mat-select
                  [(ngModel)]="paymentConfigForm.data['gatewayName']"
                  name="gatewayName"
                  (ngModelChange)="onGatewayChange()"
                  [placeholder]="'PaymentS.Form.SELECT_GATEWAY' | translate"
                  required
                >
                  <mat-option
                    *ngFor="let gateway of gateways"
                    [value]="gateway"
                  >
                    {{ gateway }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <small class="text-muted">{{
                "PaymentS.Form.Gateway_Name_Details" | translate
              }}</small>
              <small class="text-danger">{{
                form.inputerror.gatewayName
              }}</small>
            </div>

            <!-- Phone Way Specific Fields -->
            <div
              *ngIf="paymentConfigForm.data['gatewayName'] === 'PhonePE'"
              class="row"
            >
              <!-- Environment -->
              <div class="form-group col-12 mb-2">
                <label class="form-label">{{
                  "PAYMENT_CONFIG.FIELDS.ENVIRONMENT" | translate
                }}</label>

                <mat-form-field appearance="outline" class="w-100">
                  <mat-select
                    [(ngModel)]="paymentConfigForm.data['env']"
                    name="env"
                    required
                  >
                    <mat-option value="" disabled>
                      {{
                        "PAYMENT_CONFIG.PLACEHOLDERS.SELECT_ENVIRONMENT"
                          | translate
                      }}
                    </mat-option>
                    <mat-option value="PRODUCTION">PRODUCTION</mat-option>
                    <mat-option value="SANDBOX">SANDBOX</mat-option>
                  </mat-select>
                </mat-form-field>
                <small class="text-muted">{{
                  "PAYMENT_CONFIG.HELP.ENVIRONMENT" | translate
                }}</small>
                <small class="text-danger">{{ form.inputerror.env }}</small>
              </div>

              <!-- Client Version -->
              <div class="form-group col-12 mb-2">
                <label class="form-label">{{
                  "PAYMENT_CONFIG.FIELDS.CLIENT_VERSION" | translate
                }}</label>
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    type="text"
                    [placeholder]="
                      'PAYMENT_CONFIG.PLACEHOLDERS.ENTER_CLIENT_VERSION'
                        | translate
                    "
                    [(ngModel)]="paymentConfigForm.data['clientVersion']"
                    name="clientVersion"
                    required
                  />
                </mat-form-field>
                <small class="text-muted">{{
                  "PAYMENT_CONFIG.HELP.CLIENT_VERSION" | translate
                }}</small>
                <small class="text-danger">{{
                  form.inputerror.clientVersion
                }}</small>
              </div>
            </div>

            <!-- API Key -->
            <div class="form-group col-12 mb-2">
              <label class="form-label">{{
                "PaymentS.Form.API_Key" | translate
              }}</label>

              <mat-form-field appearance="outline" class="w-100">
                <input
                  matInput
                  type="text"
                  [placeholder]="'PaymentS.Form.API_Key_Place' | translate"
                  [(ngModel)]="paymentConfigForm.data['apiKey']"
                  name="apiKey"
                  required
                />
              </mat-form-field>

              <small class="text-muted">{{
                "PaymentS.Form.API_Key_Details" | translate
              }}</small>
              <small class="text-danger">{{ form.inputerror.apiKey }}</small>
            </div>

            <!-- API Secret -->
            <div class="form-group col-12 mb-2">
              <label class="form-label">{{
                "PaymentS.Form.API_Secret" | translate
              }}</label>

              <mat-form-field appearance="outline" class="w-100">
                <input
                  matInput
                  [type]="hideApiSecret ? 'password' : 'text'"
                  [placeholder]="'PaymentS.Form.ENTER_API_SECRET' | translate"
                  [(ngModel)]="paymentConfigForm.data['apiSecret']"
                  name="apiSecret"
                  required
                />
                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  class="icon-pd-none text-secondary"
                  (click)="hideApiSecret = !hideApiSecret"
                >
                  <mat-icon class="icon-compact">{{
                    hideApiSecret ? "visibility_off" : "visibility"
                  }}</mat-icon>
                </button>
              </mat-form-field>
              <small class="text-muted">{{
                "PaymentS.Form.API_Secret_Details" | translate
              }}</small>
              <small class="text-danger">{{ form.inputerror.apiSecret }}</small>
            </div>

            <!-- Merchant ID -->
            <div class="form-group col-12 mb-2">
              <label class="form-label">{{
                "PaymentS.Form.Merchant_ID" | translate
              }}</label>
              <mat-form-field appearance="outline" class="w-100">
                <input
                  matInput
                  type="text"
                  [placeholder]="'PaymentS.Form.Merchant_ID_Place' | translate"
                  [(ngModel)]="paymentConfigForm.data['merchantId']"
                  name="merchantId"
                />
              </mat-form-field>

              <small class="text-muted">{{
                "PaymentS.Form.Merchant_ID_Details" | translate
              }}</small>
              <small class="text-danger">{{
                form.inputerror.merchantId
              }}</small>
            </div>

            <!-- Callback URL -->
            <div class="form-group col-12 mb-2">
              <label class="form-label">{{
                "PaymentS.Form.Callback_URL" | translate
              }}</label>
              <mat-form-field appearance="outline" class="w-100">
                <input
                  matInput
                  type="url"
                  placeholder="https://yourdomain.com/callback"
                  [(ngModel)]="paymentConfigForm.data['callbackUrl']"
                  name="callbackUrl"
                />
                <mat-icon matSuffix class="icon-pd-none text-secondary"
                  >link</mat-icon
                >
              </mat-form-field>
              <small class="text-muted">{{
                "PaymentS.Form.Callback_URL_Details" | translate
              }}</small>
              <small class="text-danger">{{
                form.inputerror.callbackUrl
              }}</small>
            </div>

            <!-- Is Active -->
            <div class="form-group col-12 mb-2">
              <label class="form-label">
                {{ "PaymentS.Form.IsActive" | translate }}
              </label>

              <mat-form-field appearance="outline" class="w-100">
                <mat-select
                  [(ngModel)]="paymentConfigForm.data['isActive']"
                  name="isActive"
                >
                  <mat-option [value]="0">False</mat-option>
                  <mat-option [value]="1">True</mat-option>
                </mat-select>
              </mat-form-field>

              <small class="text-muted">
                {{ "PaymentS.Form.IsActive_Details" | translate }}
              </small>
              <small class="text-danger">
                {{ form.inputerror.isActive }}
              </small>
            </div>
          </form>

          <!-- Card Footer / Buttons -->

          <div class="d-flex justify-content-end gap-3 py-3">
            <button
              type="button"
              mat-stroked-button
              color="primary"
              [disabled]="!paymentForm.valid"
              (click)="savePaymentConfig()"
            >
              <mat-icon>save</mat-icon>
              {{ "PaymentS.Form.Save" | translate }}
            </button>

            <button
              type="button"
              mat-stroked-button
              color="warn"
              (click)="goBack()"
            >
              <mat-icon>close</mat-icon>
              {{ "PaymentS.Form.Cancel" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>